// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from '../../../router'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import '@/common/css/index.styl'
import '@/common/css/common.css'
import fetch from '../../api/http'
import VueWechatTitle from 'vue-wechat-title'
import store from '../../stroe'
require("@/common/css/vue2-scrollbar.css")


Vue.use(VueWechatTitle)
Vue.use(ElementUI)


Vue.config.productionTip = false
Vue.prototype.$http = fetch
window.Promise = Promise
/*增加eventbus*/
const eventBus=new Vue();
Vue.prototype.$events=eventBus;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js